'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useSearchParams } from 'next/navigation';
import { useQueryState } from 'nuqs';
import { useCallback, useMemo } from 'react';
import { findNextAvailableMonth, findPreviousAvailableMonth } from '../../lib/month-navigation-utils';
import { formatMonthDisplay, formatMonthString, isMonthAvailable, isSameMonth, normalizeMonth, parseMonthString } from '../../lib/month-utils';
import { viewMonthSearchParamParser } from '../../lib/search-params-client';
import type { Route } from 'next';
interface UseMonthNavigationProps {
  availableMonths: Date[];
  defaultMonth: Date;
}
function useMonthNavigation(t0) {
  const $ = _c(22);
  const {
    availableMonths,
    defaultMonth
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [viewMonth] = useQueryState("viewMonth", viewMonthSearchParamParser);
  let t1;
  if ($[0] !== availableMonths || $[1] !== defaultMonth || $[2] !== viewMonth) {
    bb0: {
      const parsedMonth = parseMonthString(viewMonth);
      if (!parsedMonth) {
        t1 = defaultMonth;
        break bb0;
      }
      if (isMonthAvailable(parsedMonth, availableMonths)) {
        t1 = normalizeMonth(parsedMonth);
        break bb0;
      }
      t1 = defaultMonth;
    }
    $[0] = availableMonths;
    $[1] = defaultMonth;
    $[2] = viewMonth;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const selectedMonth = t1;
  let t2;
  if ($[4] !== availableMonths || $[5] !== selectedMonth) {
    t2 = findPreviousAvailableMonth(selectedMonth, availableMonths);
    $[4] = availableMonths;
    $[5] = selectedMonth;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const previousMonth = t2;
  let t3;
  if ($[7] !== availableMonths || $[8] !== selectedMonth) {
    t3 = findNextAvailableMonth(selectedMonth, availableMonths);
    $[7] = availableMonths;
    $[8] = selectedMonth;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const nextMonth = t3;
  let t4;
  if ($[10] !== defaultMonth || $[11] !== pathname || $[12] !== searchParams) {
    t4 = month => {
      const params = new URLSearchParams(searchParams.toString());
      if (month === null || isSameMonth(month, defaultMonth)) {
        params.delete("viewMonth");
      } else {
        params.set("viewMonth", formatMonthString(month));
      }
      const queryString = params.toString();
      return (queryString ? `${pathname}?${queryString}` : pathname) as Route;
    };
    $[10] = defaultMonth;
    $[11] = pathname;
    $[12] = searchParams;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const createUrl = t4;
  let t5;
  if ($[14] !== selectedMonth) {
    t5 = formatMonthDisplay(selectedMonth);
    $[14] = selectedMonth;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== createUrl || $[17] !== nextMonth || $[18] !== previousMonth || $[19] !== selectedMonth || $[20] !== t5) {
    t6 = {
      selectedMonth,
      selectedMonthDisplay: t5,
      previousMonth,
      nextMonth,
      createUrl
    };
    $[16] = createUrl;
    $[17] = nextMonth;
    $[18] = previousMonth;
    $[19] = selectedMonth;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
}
export { useMonthNavigation };